import {name, version} from '../../package.json';

export const SDK_NAME: string = name;
export const SDK_VERSION: string = version;
